module.exports = __webpack_public_path__ + "f05618f22fa4fc92d77bfb416846a550.svg";